import React, { useRef } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";

import Slider from "react-slick";
import "./ClientTestimonial.css";

const testimonials = [
  {
    name: "Kulsum Nakiranda",
    testimonial: `Had the best time ever in Dubai! The hotel was nice and deserving and the hospitality was top notch! Am looking forward to traveling with blueberry travel always!...Thank you Blueberry Travel 👏👏`
  },
  {
    name: "lova RAMANANDRAIBE",
    testimonial: `Qualité de service très satisfaisante. Personnel accueillant et à l'écoute. Merci à Toky d'avoir été parmis nous pour ce voyage à Dubai pendant le week end pascal. Nous sommes partis en famille et les enfants ont beaucoup aimé. Les 5 jours sont vite passés.`
  },
  {
    name: "RAZAFIMANANTSOA emma",
    testimonial: `Voyage organisé sur mesure, selon notre disponibilité et notre moyen financière. Nous avons déjà fait deux voyages avec Blueberry Travel, l'année 2018 pour Dubai et Inde et l'année 2023 pour Malaisie et Singapour. Nous sommes toujours satisfait de son service. A conseiller 👌`
  },
  {
    name: "Mary Phiri ",
    testimonial: `Hey, i really enjoyed my stay in Dubai thank u Blueberry Travel. My Best Experience was the Safari Dessert, the guide/driver OMG was so welcoming & homely i highly recommend him …!👍
`
  },
  {
    name: "Kirya Musa",
    testimonial: `This was my best vacation so far, very affordable and exciting Dubai tour.
Thank you BB. Everything was super organized to the dot, no error. All our tour guides and driver were always on time and nice.
Thank you Kushal and your team. I should be back soon`
  },
  {
    name: "Joseph Mberenge",
    testimonial: `The service were conducted at higher level. The drivers kept time always and took us to all places we were supposed to visit. The organizers kept us updated all the time. Thanks Blueberry Travel. Hope to travel with you next time.`
  },
  {
    name: "Nadim Khan",
    testimonial: `Amazing service delivery and great staff to offer their services. Safari vehicle was awesome with professional driver/guide and always clean with dusty park roads. Ease in getting Visas across border travels as well. Kudos keep up the good work 👏💯`
  }
];

const ClientTestimonial = () => {
  const sliderRef = useRef(null);

  const settings = {
    className: "center",
    centerMode: true,
    centerPadding: "60px",
    infinite: true,
    speed: 300,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 480, // For mobile screens
        settings: {
          slidesToShow: 1, // Show only one card
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };


  // Component to render 5 stars
  const FiveStars = () => (
    <div className="stars-container d-flex gap-1">
      {[...Array(5)].map((_, index) => (
        <img
          effect="blur"
          key={index}
          loading="lazy"
          fetchpriority="high"
          src="https://blueberrywebsites.azureedge.net/bbt/icons/clientStar%20Full.svg"
          alt="star"
          className="stars-imgreview"
        />
      ))}
    </div>
  );

  return (
    <div className="client-testimonial container">
      <h1 className="headings">
        <span>CLIENTS</span> TESTIMONIALS
      </h1>
      <Slider {...settings} ref={sliderRef}>
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <h3>{testimonial.name}</h3>
            <FiveStars />
            <p className="testimonial">{testimonial.testimonial}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ClientTestimonial;